export default __webpack_public_path__ + "static/media/git-branch.c1748f6a.svg";